import {makeFlexibleDates, makeDays, makeDaysFromDate} from './itinerario/actions/utils'
import {makeFlights, makeEmptyFlightFilter} from './itinerario/actions/flights'
import {makeFlightDepartureInfo} from './itinerario/actions/flightDepartureInfo'
import {makeHotels, addReplaceHotel, makeEmptyHotelFilter} from './itinerario/actions/hotels'
import {makeService, makeServices, addReplaceServizioAction, removeSelectedServizio, removeSelectedServizioAll, makeEmptyServizioFilter} from './itinerario/actions/services'
import {makeSpeseAccessorie} from './itinerario/actions/spese'
import {makeEmptyTourFilter, makeTour} from './itinerario/actions/tour'
import {makeEmptyExperienceFilter} from './itinerario/actions/experience'
import {updateSummary} from './itinerario/actions/summary'
import {PRODUCT_EXPERIENCE, PRODUCT_TOUR, PRODUCT_VOLO_HOTEL} from '../../types/products'
import searchGetters from './itinerario/getters/search'
import summaryGetters from './itinerario/getters/itinerario'
import flightGetters from './itinerario/getters/flight'
import flightDepartureInfoGetters from './itinerario/getters/flightDepartureInfo'
import hotelGetters from './itinerario/getters/hotel'
import serviceGetters from './itinerario/getters/service'
import tourGetters from './itinerario/getters/tour'
import experienceGetters from './itinerario/getters/experience'
import speseGetters from './itinerario/getters/spese'
import preventivoGetters from './itinerario/getters/preventivo'
import {toDateFromServer} from '../../utils/formatter'

// loading event
export const LOAD_FLIGHTS = 'LOAD_FLIGHTS'
export const LOAD_FLIGHT_DEPARTURE_INFO = 'LOAD_FLIGHT_DEPARTURE_INFO'
export const LOAD_FLEXIBLE_DATES = 'LOAD_FLEXIBLE_DATES'
export const LOAD_HOTELS = 'LOAD_HOTELS'
export const LOAD_SERVIZI = 'LOAD_SERVIZI'
export const LOAD_TRASFERIMENTI = 'LOAD_TRASFERIMENTI'
export const LOAD_EXPERIENCES = 'LOAD_EXPERIENCES'
export const LOAD_SPESE = 'LOAD_SPESE'
export const LOAD_PREVENTIVO = 'LOAD_PREVENTIVO'

// saving event
export const ADD_SEARCH = 'ADD_SEARCH'
export const MODIFY_SEARCH = 'MODIFY_SEARCH'
export const MODIFY_FLIGHT_FILTER_FROM = 'MODIFY_FLIGHT_FILTER_FROM'
export const MODIFY_FLIGHT_FILTER_TO = 'MODIFY_FLIGHT_FILTER_TO'
export const ADD_TRASFERIMENTO = 'ADD_TRASFERIMENTO'
export const REMOVE_TRASFERIMENTO = 'REMOVE_TRASFERIMENTO'
export const REMOVE_TRASFERIMENTI = 'REMOVE_TRASFERIMENTI'
export const MODIFY_TRASFERIMENTO_FILTER = 'MODIFY_TRASFERIMENTO_FILTER'
export const MODIFY_TRASFERIMENTO_ORDER = 'MODIFY_TRASFERIMENTO_ORDER'
export const UPDATE_TRASFERIMENTO_ANDATA_DATE = 'UPDATE_TRASFERIMENTO_ANDATA_DATE'
export const ADD_HOTEL = 'ADD_HOTEL'
export const ADD_ROOM_HOTEL = 'ADD_ROOM_HOTEL'
export const MODIFY_HOTEL_FILTER = 'MODIFY_HOTEL_FILTER'
export const MODIFY_HOTEL_ORDER = 'MODIFY_HOTEL_ORDER'
export const REMOVE_HOTEL = 'REMOVE_HOTEL'
export const ADD_SERVIZIO = 'ADD_SERVIZIO'
export const REMOVE_SERVIZIO = 'REMOVE_SERVIZIO'
export const REMOVE_SERVIZIO_ALL = 'REMOVE_SERVIZIO_ALL'
export const MODIFY_SERVIZIO_FILTER = 'MODIFY_SERVIZIO_FILTER'
export const MODIFY_SERVIZIO_ORDER = 'MODIFY_SERVIZIO_ORDER'
export const ADD_TOUR = 'ADD_TOUR'
export const MODIFY_TOUR_FILTER = 'MODIFY_TOUR_FILTER'
export const MODIFY_TOUR_ORDER = 'MODIFY_TOUR_ORDER'
export const UPDATE_TOUR_PRICE_SELECTION = 'UPDATE_TOUR_PRICE_SELECTION'
export const RESET_ITINERARIO = 'RESET_ITINERAIO'
export const UPDATE_SUMMARY = 'UPDATE_SUMMARY'
export const MODIFY_EXPERIENCE_FILTER = 'MODIFY_EXPERIENCE_FILTER'
export const MODIFY_EXPERIENCE_ORDER = 'MODIFY_EXPERIENCE_ORDER'
export const MODIFY_EXPERIENCE = 'MODIFY_EXPERIENCE'
export const SELECT_SPESA = 'SELECT_SPESA'
export const RESET_SPESE = 'RESET_SPESE'

// selecting event
export const SELECT_FLIGHT_FROM = 'SELECT_FLIGHT_FROM'
export const SELECT_FLIGHT_TO = 'SELECT_FLIGHT_TO'

const initialState = () => {
  return {
    summary: {
      flights: 0,
      nights: 0,
      services: 0,
      adults: 0,
      childs: 0,
      totalPrice: 0,
      totalPricePerPerson: 0
    },
    search: {},
    days: [],
    flights: {
      list: [],
      listFrom: [],
      listTo: [],
      from: null,
      to: null,
      flexibleDates: [],
      filterFrom: makeEmptyFlightFilter(),
      filterTo: makeEmptyFlightFilter()
    },
    flightDepartureInfo: {
      arrivalPeriod: null,
      flightTransferService: null,
      selectedDate: null
    },
    hotels: {
      list: [],
      filter: makeEmptyHotelFilter(),
      order: {
        prezzo: 'up'
      }
    },
    services: {
      list: [],
      selected: [],
      filter: makeEmptyServizioFilter(),
      order: {
        prezzo: 'up'
      }
    },
    trasferimenti: {
      andata: null,
      ritorno: null,
      list: [],
      filter: makeEmptyServizioFilter(),
      order: {
        prezzo: 'up'
      }
    },
    tour: {
      detailResponses: [],
      filter: makeEmptyTourFilter(),
      order: {
        prezzo: 'up'
      }
    },
    experience: {
      list: [],
      selected: null,
      prices: [],
      filter: makeEmptyExperienceFilter(),
      order: {
        categoria: 'up'
      }
    },
    spese: [],
    preventivo: null
  }
}

const state = initialState

const getters = {
  ...searchGetters,
  ...summaryGetters,
  ...flightGetters,
  ...flightDepartureInfoGetters,
  ...hotelGetters,
  ...serviceGetters,
  ...tourGetters,
  ...experienceGetters,
  ...speseGetters,
  ...preventivoGetters
}

const mutations = {
  [UPDATE_SUMMARY] (state) {
    updateSummary(state)
  },
  [RESET_ITINERARIO] (state) {
    const s = initialState()
    Object.keys(s).forEach(key => {
      state[key] = s[key]
    })
  },
  [LOAD_FLIGHTS] (state, {list, vettori}) {
    state.flights.list = [...list]
    state.flights.listFrom = makeFlights(list, vettori, true)
    state.flights.from = state.flights.listFrom[0]
    state.flights.listTo = makeFlights(list, vettori, false)
    state.flights.to = state.flights.listTo[0]
    state.flights.filterFrom = makeEmptyFlightFilter()
    state.flights.filterTo = makeEmptyFlightFilter()
    updateSummary(state)
  },
  [LOAD_FLIGHT_DEPARTURE_INFO] (state, payload) {
    const payloadNormalized = {...payload}
    if (payload.flightTransferService) {
      payloadNormalized.flightTransferService = makeService(payload.flightTransferService)
      payloadNormalized.flightTransferService.groups.forEach(group => { group.dateSelected = payload.dateSelected })
    }
    state.flightDepartureInfo = makeFlightDepartureInfo(state, payloadNormalized)
  },
  [LOAD_FLEXIBLE_DATES] (state, payload) {
    state.flights.flexibleDates = makeFlexibleDates(state, payload)
  },
  [LOAD_HOTELS] (state, payload) {
    state.hotels.list = makeHotels(state, payload)
  },
  [LOAD_SERVIZI] (state, {list, trasferimenti}) {
    state.services.list = makeServices(list, trasferimenti, true)
  },
  [LOAD_TRASFERIMENTI] (state, {list, trasferimenti}) {
    state.trasferimenti.list = makeServices(list, trasferimenti, false)
  },
  [LOAD_EXPERIENCES] (state, payload) {
    state.experience.list = [...payload]
  },
  [LOAD_SPESE] (state, payload) {
    state.spese = makeSpeseAccessorie(payload)
  },
  [LOAD_PREVENTIVO] (state, payload) {
    state.preventivo = {...payload}
  },
  [ADD_SEARCH] (state, payload) {
    state.search = {...payload, camere: [...payload.camere]}
    if (state.search.product === PRODUCT_VOLO_HOTEL) {
      state.days = makeDays(state.search)
    } else if (state.search.product === PRODUCT_TOUR) {
      // days è calcolato direttamente in ItinerarioTour.vue
    } else if (state.search.product === PRODUCT_EXPERIENCE) {
      if (state.experience.selected) {
        console.log('***********************')
        console.log(state.search.partenza)
        console.log(payload.isGiornoSuccessivoObbligatorio)
        console.log(state.experience.selected.days.length)
        const delta = payload.isGiornoSuccessivoObbligatorio ? 1 : 0
        state.days = makeDaysFromDate(state.search.partenza, state.experience.selected.days.length + delta)
      }
    }
  },
  [MODIFY_SEARCH] (state, payload) {
    state.search = {...payload, camere: [...payload.camere]}
    state.days = makeDays(state.search)
  },
  [MODIFY_FLIGHT_FILTER_FROM] (state, payload) {
    state.flights.filterFrom = {...payload}
  },
  [MODIFY_FLIGHT_FILTER_TO] (state, payload) {
    state.flights.filterTo = {...payload}
  },
  [SELECT_FLIGHT_FROM] (state, payload) {
    state.flights.from = {...payload}
  },
  [SELECT_FLIGHT_TO] (state, payload) {
    state.flights.to = {...payload}
  },
  [ADD_TRASFERIMENTO] (state, obj) {
    state.list[obj.day].traferimento = {...obj.payload}
  },
  [REMOVE_TRASFERIMENTO] (state, day) {
    state.list[day].traferimento = null
  },
  [REMOVE_TRASFERIMENTI] (state) {
    state.trasferimenti.andata = null
    state.trasferimenti.ritorno = null
  },
  [MODIFY_TRASFERIMENTO_FILTER] (state, payload) {
    state.trasferimenti.filter = {...payload}
  },
  [MODIFY_TRASFERIMENTO_ORDER] (state, payload) {
    state.trasferimenti.order = {...payload}
  },
  [UPDATE_TRASFERIMENTO_ANDATA_DATE] (state, payload) {
    if (state.trasferimenti.andata) {
      state.trasferimenti.andata.groups.forEach(group => { group.dateSelected = payload })
    }
  },
  [ADD_HOTEL] (state, payload) {
    addReplaceHotel(state, payload)
  },
  [REMOVE_HOTEL] (state, day) {
  },
  [MODIFY_HOTEL_FILTER] (state, payload) {
    state.hotels.filter = {...payload}
  },
  [MODIFY_HOTEL_ORDER] (state, payload) {
    state.hotels.order = {...payload}
  },
  [ADD_SERVIZIO] (state, payload) {
    addReplaceServizioAction(state, payload)
  },
  [MODIFY_SERVIZIO_FILTER] (state, payload) {
    state.services.filter = {...payload}
  },
  [MODIFY_SERVIZIO_ORDER] (state, payload) {
    state.services.order = {...payload}
  },
  [ADD_TOUR] (state, payload) {
    state.tour = makeTour(payload)
  },
  [MODIFY_TOUR_FILTER] (state, payload) {
    state.tour.filter = {...payload}
  },
  [MODIFY_TOUR_ORDER] (state, payload) {
    state.tour.order = {...payload}
  },
  [UPDATE_TOUR_PRICE_SELECTION] (state, payload) {
    state.tour.groups = [...payload]
  },
  [REMOVE_SERVIZIO] (state, payload) {
    removeSelectedServizio(state, payload)
  },
  [REMOVE_SERVIZIO_ALL] (state, payload) {
    removeSelectedServizioAll(state, payload)
  },
  [MODIFY_EXPERIENCE_FILTER] (state, payload) {
    state.experience.filter = {...payload}
  },
  [MODIFY_EXPERIENCE_ORDER] (state, payload) {
    state.experience.order = {...payload}
  },
  [MODIFY_EXPERIENCE] (state, payload) {
    state.experience.selected = {...payload}
  },
  [SELECT_SPESA] (state, payload) {
    if (state.spese.length === 0) return
    state.spese[payload.index].forEach(item => {
      item.selected = false
    })
    const item = state.spese[payload.index].find(item => item.itemId === payload.itemId)
    if (item) item.selected = true
  },
  [RESET_SPESE] (state) {
    state.spese = []
  }
}

const actions = {
  resetItinerario ({ commit }) {
    commit(RESET_ITINERARIO, {...initialState})
  },
  loadFlights ({ commit, state, rootGetters }, list) {
    commit(LOAD_FLIGHTS, {list, vettori: rootGetters.getVettori})
  },
  loadFlightDepartureInfo ({ commit, state }, payload) {
    commit(LOAD_FLIGHT_DEPARTURE_INFO, payload)
  },
  loadFlexibleDates ({ commit, state }, list) {
    commit(LOAD_FLEXIBLE_DATES, list)
  },
  loadHotels ({ commit, state }, list) {
    commit(LOAD_HOTELS, list)
  },
  loadServizi ({ commit, state, rootGetters }, list) {
    commit(LOAD_SERVIZI, {list, trasferimenti: rootGetters.getAllTrasferimentiCodes})
  },
  loadTrasferimenti ({ commit, state, rootGetters }, list) {
    commit(LOAD_TRASFERIMENTI, {list, trasferimenti: rootGetters.getAllTrasferimentiCodes})
  },
  loadExperiences ({ commit, state }, list) {
    commit(LOAD_EXPERIENCES, list)
  },
  loadSpeseAccessorie ({ commit, state }, payload) {
    commit(LOAD_SPESE, payload)
    commit(UPDATE_SUMMARY, state)
  },
  loadPreventivo ({ commit, state }, payload) {
    commit(LOAD_PREVENTIVO, payload)
  },
  addSearch ({ commit, state }, payload) {
    commit(ADD_SEARCH, payload)
    commit(UPDATE_SUMMARY, state)
  },
  modifySearch ({ commit, state }, payload) {
    commit(MODIFY_SEARCH, payload)
    commit(RESET_ITINERARIO)
  },
  modifyFlightFilterFrom ({ commit, state }, payload) {
    commit(MODIFY_FLIGHT_FILTER_FROM, payload)
  },
  modifyFlightFilterTo ({ commit, state }, payload) {
    commit(MODIFY_FLIGHT_FILTER_TO, payload)
  },
  resetFlightFilterFrom ({ commit }) {
    commit(MODIFY_FLIGHT_FILTER_FROM, makeEmptyFlightFilter())
  },
  resetFlightFilterTo ({ commit }) {
    commit(MODIFY_FLIGHT_FILTER_TO, makeEmptyFlightFilter())
  },
  selectFlightFrom ({ commit, state }, payload) {
    commit(SELECT_FLIGHT_FROM, payload)
    const dateSelected = toDateFromServer(payload.voli[payload.voli.length - 1].destinazione.dataOra.date.date)
    commit(UPDATE_TRASFERIMENTO_ANDATA_DATE, dateSelected)
    commit(UPDATE_SUMMARY, state)
  },
  selectFlightTo ({ commit, state }, payload) {
    commit(SELECT_FLIGHT_TO, payload)
    commit(UPDATE_SUMMARY, state)
  },
  addTrasferimento ({ commit, state }, day, payload) {
    commit(ADD_TRASFERIMENTO, {day, payload})
    commit(UPDATE_SUMMARY, state)
  },
  removeTrasferimento ({ commit, state }, day) {
    commit(REMOVE_TRASFERIMENTO, day)
    commit(UPDATE_SUMMARY, state)
  },
  removeTrasferimenti ({ commit, state }) {
    commit(REMOVE_TRASFERIMENTI)
    commit(UPDATE_SUMMARY, state)
  },
  addHotel ({ commit, state }, payload) {
    commit(ADD_HOTEL, payload)
    commit(UPDATE_SUMMARY, state)
  },
  addRoomHotel ({ commit, state }, payload) {
    commit(ADD_ROOM_HOTEL, payload)
  },
  modifyHotelFilter ({ commit, state }, payload) {
    commit(MODIFY_HOTEL_FILTER, payload)
  },
  resetHotelFilter ({ commit }) {
    commit(MODIFY_HOTEL_FILTER, makeEmptyHotelFilter())
  },
  modifyHotelOrder ({ commit, state }, payload) {
    commit(MODIFY_HOTEL_ORDER, payload)
  },
  addReplaceServizio ({ commit, state }, payload) {
    commit(ADD_SERVIZIO, payload)
    commit(UPDATE_SUMMARY, state)
  },
  removeSelectedServizio ({ commit, state }, payload) {
    commit(REMOVE_SERVIZIO, payload)
    commit(UPDATE_SUMMARY, state)
  },
  removeSelectedServizioAll ({ commit, state }, payload) {
    commit(REMOVE_SERVIZIO_ALL, payload)
    commit(UPDATE_SUMMARY, state)
  },
  modifyTrasferimentoFilter ({ commit, state }, payload) {
    commit(MODIFY_TRASFERIMENTO_FILTER, payload)
  },
  resetTrasferimentoFilter ({ commit }) {
    commit(MODIFY_TRASFERIMENTO_FILTER, makeEmptyServizioFilter())
  },
  modifyTrasferimentoOrder ({ commit, state }, payload) {
    commit(MODIFY_TRASFERIMENTO_ORDER, payload)
  },
  modifyServiziFilter ({ commit, state }, payload) {
    commit(MODIFY_SERVIZIO_FILTER, payload)
  },
  resetServiziFilter ({ commit }) {
    commit(MODIFY_SERVIZIO_FILTER, makeEmptyServizioFilter())
  },
  modifyServiziOrder ({ commit, state }, payload) {
    commit(MODIFY_SERVIZIO_ORDER, payload)
  },
  addTour ({ commit, state }, payload) {
    commit(ADD_TOUR, payload)
    commit(UPDATE_SUMMARY, state)
  },
  modifyTourFilter ({ commit, state }, payload) {
    commit(MODIFY_TOUR_FILTER, payload)
  },
  resetTourFilter ({ commit }) {
    commit(MODIFY_TOUR_FILTER, makeEmptyTourFilter())
  },
  modifyTourOrder ({ commit, state }, payload) {
    commit(MODIFY_TOUR_ORDER, payload)
  },
  updateTourPriceSelection ({ commit, state }, payload) {
    commit(UPDATE_TOUR_PRICE_SELECTION, payload)
    commit(UPDATE_SUMMARY, state)
  },
  modifyExperienceFilter ({ commit, state }, payload) {
    commit(MODIFY_EXPERIENCE_FILTER, payload)
  },
  resetExperienceFilter ({ commit }) {
    commit(MODIFY_EXPERIENCE_FILTER, makeEmptyExperienceFilter())
  },
  modifyExperienceOrder ({ commit, state }, payload) {
    commit(MODIFY_EXPERIENCE_ORDER, payload)
  },
  modifyExperience ({ commit, state }, payload) {
    commit(MODIFY_EXPERIENCE, payload)
  },
  selectSpesa ({ commit, state }, payload) {
    commit(SELECT_SPESA, payload)
    commit(UPDATE_SUMMARY, state)
  },
  resetSpese ({ commit, state }) {
    commit(RESET_SPESE)
    commit(UPDATE_SUMMARY, state)
  },
  updateSummary ({ commit, state }) {
    commit(UPDATE_SUMMARY, state)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/front/store/modules/itinerario.js